var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-update-classroom-address-wrap" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "请更新教室地址",
            width: "600px",
            visible: _vm.visible,
            "show-close": false,
            "before-close": _vm.onCloseEvent
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "m-content-wrap flex-column" }, [
            _c("div", { staticClass: "m-content__title" }, [
              _vm._v(
                "当前“培训教室”无地址，会导致学员无法扫码" +
                  _vm._s(_vm.signTypeName) +
                  "学习！"
              )
            ]),
            _c(
              "div",
              { staticClass: "m-content__form flex-column" },
              [
                _c("div", { staticClass: "m-form__tip flex-row" }, [
                  _c("i", { staticClass: "el-icon-warning m-tip__icon" }),
                  _c("div", [
                    _vm._v(" 请在下方填写"),
                    _c("span", { staticClass: "m-tip__red-text" }, [
                      _vm._v("【培训教室地址】")
                    ]),
                    _vm.isSupportApp
                      ? _c("span", [
                          _vm._v("或者"),
                          _c("span", { staticClass: "m-tip__red-text" }, [
                            _vm._v("【安全管理员-“扫码签到”】")
                          ]),
                          _vm._v("在手机上更新教室地址！")
                        ])
                      : _vm._e()
                  ])
                ]),
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      "validate-on-rule-change": false,
                      model: _vm.formObject,
                      rules: _vm.getRule,
                      inline: true
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "培训教室地址",
                          prop: "classroomAddress"
                        }
                      },
                      [
                        _c("el-autocomplete", {
                          attrs: {
                            "fetch-suggestions": _vm.querySearchAsync,
                            placeholder: "请输入详细地址",
                            "select-when-unmatched": false,
                            size: "medium"
                          },
                          on: {
                            select: _vm.monitorDetailAddressChange,
                            blur: _vm.validateInputBlur
                          },
                          model: {
                            value: _vm.formObject.classroomAddress,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.formObject,
                                "classroomAddress",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "formObject.classroomAddress"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "cancel-button",
                  attrs: { size: "medium" },
                  on: { click: _vm.onSureClose }
                },
                [_vm._v(_vm._s(_vm.isSupportApp ? "扫码签到" : "关闭"))]
              ),
              _c(
                "el-button",
                {
                  staticClass: "ensure-button",
                  attrs: { size: "medium", loading: _vm.loading },
                  on: { click: _vm.onSureEvent }
                },
                [_vm._v("确认地址")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }